"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPluginPackage = void 0;
var types_1 = require("../types");
var tracing_js_1 = require("@web3api/tracing-js");
exports.findPluginPackage = tracing_js_1.Tracer.traceFunc("core: findPluginPackage", function (uri, plugins) {
    var pluginRedirect = plugins.find(function (x) { return types_1.Uri.equals(x.uri, uri); });
    return pluginRedirect === null || pluginRedirect === void 0 ? void 0 : pluginRedirect.plugin;
});
//# sourceMappingURL=find-plugin-package.js.map